const conf_email = document.getElementById("field_conf_emailaddress_label");

if ( conf_email !== null ) {
	conf_email.innerHTML = "Bevestig dit e-mailadres <span class='frm_required'>*</span>";
	conf_email.style.visibility = 'visible';
}

const friend_form_amount = document.getElementById("field_friend_form_amount");
const label_friend_form_amount = document.getElementById("betaling_value");
const field_friend_type = document.getElementById("field_friend_type")

if ( friend_form_amount !== null && label_friend_form_amount !== null ) {
	friend_form_amount.addEventListener( "change", function (event) {
		label_friend_form_amount.textContent = friend_form_amount.value;

		if ( friend_form_amount.value > 74 && friend_form_amount.value < 200 ) {
			field_friend_type.value = "NDT VRIENDEN";
		} else if ( friend_form_amount.value > 199 && friend_form_amount.value < 1500 ) {
			field_friend_type.value = "NDT MUZEN";
		} else if ( friend_form_amount.value > 1499 && friend_form_amount.value < 5000 ) {
			field_friend_type.value = "NDT PATRON CIRKEL";
		} else if ( friend_form_amount.value > 4999 && friend_form_amount.value < 10000 ) {
			field_friend_type.value = "NDT DANSER CIRKEL";
		} else if ( friend_form_amount.value > 9999 ) {
			field_friend_type.value = "NDT CHOREOGRAAF CIRKEL";
		} else {
			field_friend_type.value = "not_valid";
		}
	});
}
